import { Grid } from '@mui/material';
import * as React from 'react';

import muiStyles from './styles';
import { StatisticWithLabelColoredProps } from './types';

export default function StatisticWithLabelColored (props: StatisticWithLabelColoredProps) {
    const {
        className,
        statistic
    } = props;

    const styles = muiStyles(props);

    return (
        <Grid
            className={`${styles.mainContainer} ${className}`}
            container
            direction='column'
        >
            <Grid item>{statistic.title}</Grid>
            <Grid
                className={styles.statValueContainer}
                item
            >
                {statistic.statistic}
            </Grid>
        </Grid>
    );
}